/**
 * App Component
 * @description TanStack Router 진입점
 */

import { useEffect } from 'react';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { PORTAL_DOCUMENT_TITLE } from '@shared/config';
import { I18nProvider } from '@shared/i18n';
import { routeTree } from './routeTree.gen';
import { useAuthStore } from '@/stores/authStore';

// 개발 환경에서 개발 도구 로드
if (import.meta.env.DEV) {
  import('@/utils/devTools');
}

// Create router instance
const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
});

// Register router for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

function App() {
  const initialize = useAuthStore((state) => state.initialize);

  useEffect(() => {
    document.title = PORTAL_DOCUMENT_TITLE;
  }, []);

  // Initialize auth state from localStorage on app start
  useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <I18nProvider>
      <RouterProvider router={router} />
    </I18nProvider>
  );
}

export default App;
